import { render, staticRenderFns } from "./homeDrag.vue?vue&type=template&id=2135d36a&scoped=true"
import script from "./homeDrag.vue?vue&type=script&lang=js"
export * from "./homeDrag.vue?vue&type=script&lang=js"
import style0 from "./homeDrag.vue?vue&type=style&index=0&id=2135d36a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_163004cd90115b55449e6d2350f1be1c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2135d36a",
  null
  
)

export default component.exports